import React from "react";

const WorkProgress = () => {
  const reasons = [
    {
      icon: (
        <svg
          className="w-16 h-16"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z"
            clipRule="evenodd"
          />
        </svg>
      ),
      title: "IT Solutions",
      description:
        "Our IT solutions, driven by talented minds, enable us to deliver innovative, professional, and high-quality products to our clients",
      step: "01",
    },
    {
      icon: (
        <svg
          className="w-16 h-16"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      ),
      title: "Consultancy for IT",
      description:
        "Our top IT consulting expertise spans over various domains and gives custom-tailored IT consulting services for organizations of any size.",
      step: "02",
    },
   {
  icon: (
    <svg className="w-16 h-16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 17.58A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 4 16.25" />
      <polyline points="16 16 12 12 8 16" />
      <line x1="12" y1="12" x2="12" y2="21" />
    </svg>
  ),
  title: "Odoo Services",
  description:
    "Seamless Odoo integration with cloud, CRM, accounting, and third-party applications to unify business operations.",
  step: "03"
}

  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-blue-600 font-medium mb-2 block">
            {/* Why People Choose us */} Here’s What Sets Us Apart
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800">
            Why People Choose Our Services
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reasons.map((item, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-lg shadow-lg relative border-b-4 border-blue-600"
            >
              <div className="text-blue-600 mb-6">{item.icon}</div>

              <h3 className="text-2xl font-bold mb-4 text-gray-800">
                {item.title}
              </h3>

              <p className="text-gray-600 mb-6">{item.description}</p>

              <span className="absolute top-8 right-8 text-4xl font-bold text-gray-200">
                {item.step}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkProgress;
